import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppState } from '../app.service';
import { I18n } from '../i18n.service';
import { HomeUiService } from '../new-design/home-ui.service';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { Path } from '../path/path-v2.model';
import { ToasterService } from '../toaster.service';
import { User } from '../user/user.model';
import { UserService } from '../user/user.service';

export interface CurrentPathRegistration {
  [pathRegistration: string]: any;
}

export interface UpdatePathRegistration {
  [updatePathRegistration: string]: any;
}

@Injectable()
export class UtilityService {

  currentPath: Path
  currentUser: User
  public pathRegistration: CurrentPathRegistration;
  public updatePathRegistration: UpdatePathRegistration;
  API_URL: string = environment.apiBaseUrl
  UPDATE_SCREENS_VIEWED = '/users/update_screens_viewed'
  PATH_COMPLETION_EMAIL = '/users/path_completion_mail'

  constructor(private appState: AppState,
    private userService: UserService,
    private toasterService: ToasterService,
    private homeUiService: HomeUiService,
    private i18n: I18n,
    private httpclient: HttpClient,private homeService: HomeV5Service
  ) {
    this.currentPath = this.appState.get('currentPath')
    this.currentUser = this.appState.get('currentUser')
    this.pathRegistration = this.appState.get('pathRegistration')
  }

  convertToArray() {
    this.currentPath = this.appState.get('currentPath')
    let jsonObject = this.currentPath.colours
    let colorArray = []
    for (let element in jsonObject) {
      if (element === 'stat1' || element === 'stat2' || element === 'stat3' || element === 'stat4' || element === 'stat5') {
        colorArray.push({
          colorCode: jsonObject[element]
        });
      }
    }
    return colorArray
  }

  public getColor(routine) {
    var array = JSON.parse(routine.pathcolours)
    return array.theme
  }



  getCurrentUserRank(stats: any) {
    var current_user
    current_user = stats?.['current_user_positions'];
    // let thisPathUserRank = stats.leaderboard.current_path_user.findIndex(element => element.isMe)
    let thisPathUserRank =current_user?.current_path_position>0?current_user?.current_path_position-1:current_user?.current_path_position
    return thisPathUserRank;
  }

  getCurrentPathUser(stats: any) {
    var current_user
    current_user = stats?.['current_user_positions'];
    // let thisUser = stats.leaderboard.current_path_user.filter(element => element.isMe)
    let userPosition = stats?.user_position?.length > 0 ? stats?.user_position[0] : stats?.user_position
    let thisPathUser = { ...userPosition }
    thisPathUser.actionPoints = current_user?.current_path_action_points
    return thisPathUser;
  }

  public updateScreenCount(data: any): Observable<any>{
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    return this.httpclient.put(this.API_URL + this.UPDATE_SCREENS_VIEWED, data, { headers })
  }

  /**
   * @param reserveLastScreen hold one screen back, for writes that are NOT the learner finishing the
   * step: the `beforeunload` write in AppComponent, and closing or leaving the step before its
   * end-of-step has run.
   *
   * The backend reads `visitedScreens == totalScreens` as "step complete". But viewing the last
   * screen is not finishing a step — the end-of-step flow still has to run. Reporting the full count
   * from a refresh or a close therefore completed the step behind the learner's back: home moved on
   * to the next step, and returning showed the REVIEW end-of-step for a step they were completing
   * for the first time. Only the write that follows `lastScreenAction()` reports the real total.
   */
  /**
   * Where the learner is, as the step screens record it: `currentScreenIndexAfterScreenView`,
   * `currentDayAfterScreenView`, `screensIdsAfterScreenView`. All three are path-owned but live in
   * global slots that outlive a cycle switch, and every guard that reads them compares step
   * POSITIONS — which both cycles have, and which readily coincide. So after a switch the previous
   * cycle's screen counts are read as if they belonged to the new one.
   *
   * Stamping the path at write time and checking it at read time closes that: a reading can only be
   * used by the cycle it was taken on.
   */
  stampScreenPosition() {
    const pathId = this.appState.get('currentPath')?.id ?? null
    this.appState.set('screenPositionPathId', pathId)
    try { localStorage.setItem('screenPositionPathId', JSON.stringify(pathId)) } catch (e) { /* storage unavailable */ }
  }

  /**
   * @param fromStorage true for callers that read the position out of localStorage rather than app
   * state, so the stamp is compared from the same place.
   */
  isScreenPositionFromCurrentPath(fromStorage = false): boolean {
    let stamped = this.appState.get('screenPositionPathId')
    if (fromStorage) {
      try {
        const raw = localStorage.getItem('screenPositionPathId')
        stamped = raw === null ? stamped : JSON.parse(raw)
      } catch (e) { /* storage unavailable; fall back to app state */ }
    }
    // Nothing stamped: a session that predates this, so leave it to the caller's own guards.
    if (stamped === undefined || stamped === null) { return true }
    return stamped === (this.appState.get('currentPath')?.id ?? null)
  }

  setScreenData(currentScreenIndex: any, currentDay: any, screensIds: any, reserveLastScreen = false) {
    let currentScreenArray = []
    currentScreenArray.push(currentScreenIndex + 1)
    const totalScreens = screensIds?.length
    const ceiling = reserveLastScreen && totalScreens > 1 ? totalScreens - 1 : totalScreens
    var stepObject = {
      step: currentDay,
      visitedScreens:currentScreenArray[0]>ceiling?ceiling: currentScreenArray[0],
      totalScreens: totalScreens,
      isScreenCompleted: false
    }
    mixpanel.track("Set screen data while moving to next screens ", {stepObject: stepObject, screenIds: screensIds})
    this.appState.set('stepObject', stepObject)
    // Stamp the path this reading belongs to. Everything it was built from — the screen index, the
    // day, the screen ids — is held in globals that outlive a cycle switch, so without this the next
    // save can carry one path's screen counts into another.
    this.appState.set('stepObjectPathId', this.appState.get('currentPath')?.id ?? null)
  }

  setScreenCount() {
    var stepsArray = []
    var stepObject = this.appState.get('stepObject')
    // Refuse a reading taken on a path the learner has since left. The guards upstream compare step
    // POSITIONS, which every path has and which readily coincide, so a stale reading passes them and
    // the previous path's progress lands on the current one — the learner then sees another cycle's
    // step data. Dropping the write is safe: the next screen change takes a fresh reading.
    const stampedPathId = this.appState.get('stepObjectPathId')
    const currentPathId = this.appState.get('currentPath')?.id ?? null
    if (stampedPathId !== undefined && stampedPathId !== null && stampedPathId !== currentPathId) {
      mixpanel.track('Dropped screen progress from a previous cycle',
        { stampedPathId, currentPathId, stepObject })
      return
    }
    var prevStepArray = []
    let pathRegistration = this.appState.get('pathRegistration')
    // Guarded: a cycle switch clears path state, and an unguarded read here threw mid-switch.
    let stepsViewed = pathRegistration?.screensViewed
    if (stepsViewed) {
      prevStepArray = stepsViewed
    } else {
      // pathRegistration is refetched per path, so it is safe. This fallback is not: `screensViewed`
      // is a global that survives a switch whose cleanup never ran — the cleanup sits in a success
      // callback at one of eleven entry points, so an API error or any other entry skips it. Treat a
      // stale array as absent; the save then starts a fresh one for the path in hand.
      const stampedArrayPathId = this.appState.get('screensViewedPathId')
      const pathInHand = this.appState.get('currentPath')?.id ?? null
      const staleArray = stampedArrayPathId !== undefined && stampedArrayPathId !== null
        && stampedArrayPathId !== pathInHand
      prevStepArray = staleArray ? undefined : this.appState.get('screensViewed')
    }

    let currentPath = this.appState.get('currentPath')
    let currentUser = this.appState.get('currentUser')

    if (prevStepArray && prevStepArray.length >= 1) {
      prevStepArray.push(stepObject)
      this.appState.set('stepsArray', prevStepArray)
      this.saveScreens(currentUser.id, currentPath.id, prevStepArray)
    } else {
      stepsArray.push(stepObject)
      this.appState.set('stepsArray', stepsArray)
      if (stepsArray && stepsArray.length >= 1) {
        this.saveScreens(currentUser.id, currentPath.id, stepsArray)
      }
    }
  }

  public async saveScreens(userId: number, pathId: number, screensViewed: any) {    
    let lastScreenViewed = screensViewed[screensViewed.length - 1]
    let lastStep = lastScreenViewed?.step - 1
    let lastVisited = lastScreenViewed?.visitedScreens
    let totalScreens = lastScreenViewed?.totalScreens
    let stepsCompleted = this.getScreensCompleted(lastStep,lastVisited,totalScreens)
    
    const requestData = {
      user_id: userId,
      path_id: pathId,
      screens_viewed: JSON.stringify(screensViewed),
      steps_completed: stepsCompleted.toString()
    }
    if (requestData.steps_completed < 0) {
      return
    }
    localStorage.setItem('stepsCompleted', stepsCompleted.toString())
    this.appState.set("screensViewed", screensViewed);
    this.appState.set("screensViewedPathId", pathId ?? null);
    this.appState.set("lastStep", lastStep);
    mixpanel.track('Screensviewed data count before api call', { screensViewData: screensViewed, inputData:requestData })
    this.updateScreenCount(requestData).subscribe(
      (response) => {
        mixpanel.track('Updated screensviewed data after api call', { screensViewData: response.data })
        this.appState.set("screensViewed", response.data);
        this.appState.set("screensViewedPathId", pathId ?? null);
        this.homeUiService.getDailyStepsInfo();
        localStorage.removeItem('currentScreenIndexAfterScreenView')
        localStorage.removeItem('currentDayAfterScreenView')
      },
      error => {
        console.log('saveScreens error', error)
        mixpanel.track("Error while saving the updateded screensViewed data",{error:error})
        this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
      }
    )
  }

  getScreensCompleted(lastStep: number,lastVisited: number,totalScreens: number){
    let stepsCompleted
    if (totalScreens >= 10) {
      let temp = lastStep + (lastVisited / totalScreens);
      // Truncated, not rounded. toFixed rounds UP, so a step of 20 screens with one deliberately held
      // back reported 19/20 = .95 as a whole number — the step read complete from the very close or
      // refresh the hold-back exists to survive. An exact ratio of 1 is unaffected, so a genuinely
      // finished step still reports the whole number.
      stepsCompleted = (Math.floor(temp * 10) / 10).toFixed(1)
      return stepsCompleted
    } else {
      stepsCompleted = lastStep + '.' + lastVisited
      return stepsCompleted
    }
  }


  public sendEmail(data): Observable<any> {
    const headers = new HttpHeaders();
     headers.set("Authorization", localStorage.getItem("token"));
    const params = new HttpParams().append('user_id', data);
    return this.httpclient.get(this.API_URL + this.PATH_COMPLETION_EMAIL, { headers, params })
  }

  stopEmbeddedVideo(){
    setTimeout(() => {
      let disableVideo = this.appState.get('disableVideo')
      const iframe = this.appState.get('iframeObject')
      if (disableVideo && iframe) {
        iframe.src = iframe.src;
      }
    }, 10);
  }

  enableHeight(textareaContainer, isMobile, platform, keyboard){
    //this code is for increasing the height of the text area for android device when keyboard pops up
    if(isMobile){
      if(platform.is('android')) {
      //  this.textareaContainer.nativeElement?.setAttribute('style', 'margin-bottom:200px;')
        keyboard.onKeyboardDidShow().subscribe((info) => {
          console.log('keyboard will show with height', info.keyboardHeight);
          // textareaContainer.nativeElement.style.setProperty(
          //   'bottom',
          //   // `${info.keyboardHeight-81}px`
          //   `${info.keyboardHeight-138}px`
          // );
          // textareaContainer.nativeElement.style.setProperty(
          //   'padding-bottom',
          //   `${300-(info.keyboardHeight-20)}px`
          // );
        });

        keyboard.onKeyboardDidHide().subscribe((info) => {
          console.log('keyboard did hide',info.keyboardHeight);
          console.log('keyboard did hide',info);
          textareaContainer.nativeElement.style.setProperty(
            'margin-bottom',
            `${0}px`
          );
          textareaContainer.nativeElement.style.setProperty(
            'bottom',
            `${75}px`
          );
          textareaContainer.nativeElement.style.setProperty(
            'padding-bottom',
            `${0}px`
          );
        });
      }
    }
  }

}
